/*
  Authors : WeAiSys (Mozib Khan)
  Website : https://weaisys.com/
  App Name : Medical Plus
  Created : 9 May 2021
  This App Template Source code is licensed as per the
  terms found in the Website https://weaisys.com/license
  Copyright and Good Faith Purchasers © 2022-present WeAiSys Helps.
*/
import { Pipe, PipeTransform } from '@angular/core';
import { UtilService } from 'src/app/services/util.service';

@Pipe({
  name: 'translate'
})
export class TranslatePipe implements PipeTransform {

  constructor(public util: UtilService) {

  }
  transform(str: string) {
    const value = this.util.translations[str];
    console.log('valueeee', value);
    if (value && value !== undefined) {
      return this.util.translations[str];
    }
    return str;
  }

}
